import { render } from "./BusinessPreview.vue?vue&type=template&id=e965533e&ts=true"
import script from "./BusinessPreview.vue?vue&type=script&lang=ts"
export * from "./BusinessPreview.vue?vue&type=script&lang=ts"

import "./BusinessPreview.vue?vue&type=style&index=0&id=e965533e&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__